module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_23.3a8a92b4.jpg";